import React from 'react';

export default function Inventory() {
  return <div>Inventory details from</div>;
}
